import React from 'react';
import { useTranslate, usePermissions, useGetList, ChipField, SingleFieldList } from 'react-admin';
import Grid from '@mui/material/Grid';
import Alert from '@mui/material/Alert';
import moment from 'moment';
import { Typography } from '@mui/material';

const NOW = moment();

const cardSx = (theme) => ({
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: theme.palette.mode === 'dark' ? theme.palette.warning.dark : theme.palette.warning.light,
    height: '100%'
});

const AdminWarningCards = () => {
    const { permissions } = usePermissions();
    const translate = useTranslate();
    const { data: users } = useGetList(
        'users',
        {
            pagination: { page: 1, perPage: 20 },
            sort: { field: 'id', order: 'ASC' }
        }
    );

    const renderWarningsTimesheet = () => {
        const usersWarnings = users?.filter(user => NOW.diff(moment(user?.last_time_entry?.date), 'days') >= 7);;
        if (usersWarnings?.length > 0) {
            return (
                <Grid size={{ xl: 3, lg: 3, sm: 6, xs: 12 }}>
                    <Alert severity="warning" sx={cardSx} >
                        <Typography>{translate('Timesheet')}</Typography>
                        <SingleFieldList data={usersWarnings} resource="users" linkType="show">
                            <ChipField source="trigram" variant="outlined" size="small" />
                        </SingleFieldList>
                    </Alert>
                </Grid>
            );
        }

        return null;
    };

    const renderWarningsWeekly = () => {
        const usersWarnings = users?.filter(user => NOW.diff(moment(user?.last_weekly?.date), 'days') >= 7);
        if (usersWarnings?.length > 0) {
            return (
                <Grid size={{ xl: 3, lg: 3, sm: 6, xs: 12 }}>
                    <Alert severity="warning" sx={cardSx} >
                        <Typography>{translate('Weeklies')}</Typography>
                        <SingleFieldList data={usersWarnings} resource="users" linkType="show">
                            <ChipField source="trigram" variant="outlined" size="small" />
                        </SingleFieldList>
                    </Alert>
                </Grid>
            );
        }

        return null;
    };

    if (permissions?.includes('is_admin')) {
        return (
            <>
                {renderWarningsTimesheet()}
                {renderWarningsWeekly()}
            </>
        );
    }

    return null;
};

export default AdminWarningCards;